import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { RxEnterFullScreen, RxExitFullScreen } from "react-icons/rx";

const FullsizeButton = ({ isAuth = true }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showFullscreenButton, setShowFullscreenButton] = useState(true);

  useEffect(() => {
    const checkIOS = () => {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };

    const iosDevice = checkIOS();

    setShowFullscreenButton(!iosDevice);
  }, []);

  useEffect(() => {
    if (!showFullscreenButton) return;

    const handleFullscreenChange = () => {
      setIsFullscreen(
        !!document.fullscreenElement ||
          !!document.webkitFullscreenElement ||
          !!document.mozFullScreenElement ||
          !!document.msFullscreenElement,
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange,
      );
    };
  }, [showFullscreenButton]);

  const toggleFullScreen = () => {
    if (!showFullscreenButton) return;

    const doc = document.documentElement;

    if (
      !document.fullscreenElement &&
      !document.webkitFullscreenElement &&
      !document.mozFullScreenElement &&
      !document.msFullscreenElement
    ) {
      if (doc.requestFullscreen) {
        doc.requestFullscreen();
      } else if (doc.webkitRequestFullscreen) {
        doc.webkitRequestFullscreen();
      } else if (doc.mozRequestFullScreen) {
        doc.mozRequestFullScreen();
      } else if (doc.msRequestFullscreen) {
        doc.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  return (
    <div
      className={`block lg:hidden fixed ${isAuth ? "top-4" : "top-20"} right-4 z-50`}
    >
      {showFullscreenButton && (
        <Tooltip
          title={
            isFullscreen
              ? "Klik untuk keluar dari layar penuh"
              : "Klik untuk masuk ke layar penuh"
          }
        >
          <button
            onClick={toggleFullScreen}
            className="p-1.5 rounded-full shadow-md bg-white opacity-80 hover:opacity-100 text-gray-600 hover:bg-stone-100 cursor-pointer transition-all duration-200 border border-gray-200"
          >
            {isFullscreen ? (
              <RxExitFullScreen size={20} />
            ) : (
              <RxEnterFullScreen size={20} />
            )}
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default FullsizeButton;
